// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1uUsB","unreadBadge":"styles_unreadBadge__bzJ9J","modalContent":"styles_modalContent__YU0NA","modal":"styles_modal__278kP"};